import { render, staticRenderFns } from "./appAdmin.vue?vue&type=template&id=46b95cc6"
import script from "./appAdmin.vue?vue&type=script&lang=js"
export * from "./appAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports